/**
 * Объект с фичами.
 * @returns {Object} Объект с фичами.
 */
export const jsonFeatures = (window.app && window.app.features) || {}
